import { useContext } from 'react';
import StudentContext, { StudentContextProps } from '../context/StudentContext';

const useStudentContext = (): StudentContextProps => useContext(StudentContext);

export default useStudentContext;
